import { FC } from "react";
import { Modal, Button } from "react-bootstrap";

interface Props {
  show: boolean;
  pathName: string;
  itemCount: number;
  onClose: () => void;
  onConfirm: () => void;
}

const RemoveJourneyPathModal: FC<Props> = ({ show, pathName, itemCount, onClose, onConfirm }) => {
  return (
    <Modal show={show} onHide={onClose} centered className="tier-2-modal" backdropClassName="tier-2-backdrop">
      <Modal.Header closeButton>
        <Modal.Title as="h5">Remove Group</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-1">
          Remove <strong>{pathName}</strong>
          {itemCount > 0 && (
            <>
              {" "}and its {itemCount} line item{itemCount === 1 ? "" : "s"}
            </>
          )}
          ?
        </p>
        <p className="text-muted small mb-0">Changes apply on Save.</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="light" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="danger" onClick={onConfirm}>
          <i className="bi bi-x-lg me-2" />
          Remove
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RemoveJourneyPathModal;
